var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgResourcesArray(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 236,
    height: 207,
    viewBox: "0 0 236 207",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_11045_71935)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M83.5999 1.6429H0.139893V97.9529H83.5999V1.6429Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.3099 53.9229H2.88989V94.2829H81.3099V53.9229Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.2799 8.5229H0.139893V14.9429H26.2799V8.5229Z",
    fill: "#8CC63F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.08984 61.6129H73.5198",
    stroke: "black",
    strokeWidth: 2.91,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.08984 68.1829H57.0498",
    stroke: "#808080",
    strokeWidth: 1.94,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.08984 73.3729H71.2898",
    stroke: "#808080",
    strokeWidth: 1.94,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.08984 79.0129L65.9498 78.5629",
    stroke: "#808080",
    strokeWidth: 1.94,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.08984 84.2029H62.3898",
    stroke: "#808080",
    strokeWidth: 1.94,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.92 0.7229H129.46V97.0329H212.92V0.7229Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.64 53.0029H132.22V93.3629H210.64V53.0029Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.6 7.6029H129.46V14.0229H155.6V7.6029Z",
    fill: "#8CC63F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.41 60.7029H202.84",
    stroke: "black",
    strokeWidth: 2.91,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.41 67.2629H186.37",
    stroke: "#808080",
    strokeWidth: 1.94,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.41 72.4629H200.62",
    stroke: "#808080",
    strokeWidth: 1.94,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.41 78.0929L195.27 77.6529",
    stroke: "#808080",
    strokeWidth: 1.94,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.41 83.2929H191.71",
    stroke: "#808080",
    strokeWidth: 1.94,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.78 110.113H31.3198V206.423H114.78V110.113Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.5 162.403H34.0798V202.763H112.5V162.403Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.4598 116.993H31.3198V123.413H57.4598V116.993Z",
    fill: "#8CC63F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.2698 170.093H104.7",
    stroke: "black",
    strokeWidth: 2.91,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.2698 176.663H88.2298",
    stroke: "#808080",
    strokeWidth: 1.94,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.2698 181.853H102.48",
    stroke: "#808080",
    strokeWidth: 1.94,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.2698 187.493L97.1298 187.043",
    stroke: "#808080",
    strokeWidth: 1.94,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.2698 192.683H93.5698",
    stroke: "#808080",
    strokeWidth: 1.94,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.85 110.113H152.39V206.423H235.85V110.113Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.57 162.403H155.15V202.763H233.57V162.403Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.53 116.993H152.39V123.413H178.53V116.993Z",
    fill: "#8CC63F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.34 170.093H225.77",
    stroke: "black",
    strokeWidth: 2.91,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.34 176.663H209.3",
    stroke: "#808080",
    strokeWidth: 1.94,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.34 181.853H223.55",
    stroke: "#808080",
    strokeWidth: 1.94,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.34 187.493L218.2 187.043",
    stroke: "#808080",
    strokeWidth: 1.94,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.34 192.683H214.64",
    stroke: "#808080",
    strokeWidth: 1.94,
    strokeMiterlimit: 10
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_11045_71935"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 235.72,
    height: 205.7,
    fill: "white",
    transform: "translate(0.139893 0.7229)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResourcesArray);
export default __webpack_public_path__ + "static/media/resources-array.dfaca1002cbba6d8f28b4d0dcea32145.svg";
export { ForwardRef as ReactComponent };